<div>
<div class="member-validation__header">Gender is Present</div>
<app-member-validation-yes-no [isChaseEnabled]=isChaseEnabled (onSelect)="handleChange($event)"></app-member-validation-yes-no>
</div>
